import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslation from './en.json'
import ruTranslation from './ru.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    resources: {
      en: {
        translation: enTranslation,
      },
      ru: {
        translation: ruTranslation,
      },
    },
    fallbackLng: 'en', // Язык, который будет использоваться, если текущий язык отсутствует
    interpolation: {
      escapeValue: false, // Не экранировать HTML и React-компоненты в тексте
    },
})

export default i18n
